/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateEventRegistrationOptionDto } from '../models/work-create-event-registration-option-dto';
import { WorkCreateEventRegistrationOptionGroupDto } from '../models/work-create-event-registration-option-group-dto';
import { WorkEventRegistrationOption } from '../models/work-event-registration-option';
import { WorkEventRegistrationOptionGroup } from '../models/work-event-registration-option-group';
import { WorkUpdateEventRegistrationOptionDto } from '../models/work-update-event-registration-option-dto';
import { WorkUpdateEventRegistrationOptionGroupDto } from '../models/work-update-event-registration-option-group-dto';

@Injectable({ providedIn: 'root' })
export class WorkEventRegistrationOptionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventRegistrationOptionsV1ControllerCreateOption()` */
  static readonly EventRegistrationOptionsV1ControllerCreateOptionPath = '/v1/event-registration-options';

  /**
   * Required permissions: events:admin, events:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventRegistrationOptionsV1ControllerCreateOption()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventRegistrationOptionsV1ControllerCreateOption$Response(
    params: {
      body: WorkCreateEventRegistrationOptionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventRegistrationOption>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventRegistrationOptionsService.EventRegistrationOptionsV1ControllerCreateOptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventRegistrationOption>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventRegistrationOptionsV1ControllerCreateOption$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventRegistrationOptionsV1ControllerCreateOption(
    params: {
      body: WorkCreateEventRegistrationOptionDto
    },
    context?: HttpContext
  ): Observable<WorkEventRegistrationOption> {
    return this.eventRegistrationOptionsV1ControllerCreateOption$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventRegistrationOption>): WorkEventRegistrationOption => r.body)
    );
  }

  /** Path part for operation `eventRegistrationOptionsV1ControllerCreateOptionGroup()` */
  static readonly EventRegistrationOptionsV1ControllerCreateOptionGroupPath = '/v1/event-registration-options/group';

  /**
   * Required permissions: events:admin, events:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventRegistrationOptionsV1ControllerCreateOptionGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventRegistrationOptionsV1ControllerCreateOptionGroup$Response(
    params: {
      body: WorkCreateEventRegistrationOptionGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventRegistrationOptionGroup>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventRegistrationOptionsService.EventRegistrationOptionsV1ControllerCreateOptionGroupPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventRegistrationOptionGroup>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventRegistrationOptionsV1ControllerCreateOptionGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventRegistrationOptionsV1ControllerCreateOptionGroup(
    params: {
      body: WorkCreateEventRegistrationOptionGroupDto
    },
    context?: HttpContext
  ): Observable<WorkEventRegistrationOptionGroup> {
    return this.eventRegistrationOptionsV1ControllerCreateOptionGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventRegistrationOptionGroup>): WorkEventRegistrationOptionGroup => r.body)
    );
  }

  /** Path part for operation `eventRegistrationOptionsV1ControllerDeleteOption()` */
  static readonly EventRegistrationOptionsV1ControllerDeleteOptionPath = '/v1/event-registration-options/{id}';

  /**
   * Required permissions: events:admin, events:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventRegistrationOptionsV1ControllerDeleteOption()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventRegistrationOptionsV1ControllerDeleteOption$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventRegistrationOptionsService.EventRegistrationOptionsV1ControllerDeleteOptionPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventRegistrationOptionsV1ControllerDeleteOption$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventRegistrationOptionsV1ControllerDeleteOption(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventRegistrationOptionsV1ControllerDeleteOption$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventRegistrationOptionsV1ControllerUpdateOption()` */
  static readonly EventRegistrationOptionsV1ControllerUpdateOptionPath = '/v1/event-registration-options/{id}';

  /**
   * Required permissions: events:admin, events:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventRegistrationOptionsV1ControllerUpdateOption()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventRegistrationOptionsV1ControllerUpdateOption$Response(
    params: {
      id: number;
      body: WorkUpdateEventRegistrationOptionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventRegistrationOptionsService.EventRegistrationOptionsV1ControllerUpdateOptionPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventRegistrationOptionsV1ControllerUpdateOption$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventRegistrationOptionsV1ControllerUpdateOption(
    params: {
      id: number;
      body: WorkUpdateEventRegistrationOptionDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventRegistrationOptionsV1ControllerUpdateOption$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventRegistrationOptionsV1ControllerDeleteOptionGroup()` */
  static readonly EventRegistrationOptionsV1ControllerDeleteOptionGroupPath = '/v1/event-registration-options/group/{id}';

  /**
   * Required permissions: events:admin, events:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventRegistrationOptionsV1ControllerDeleteOptionGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventRegistrationOptionsV1ControllerDeleteOptionGroup$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventRegistrationOptionsService.EventRegistrationOptionsV1ControllerDeleteOptionGroupPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventRegistrationOptionsV1ControllerDeleteOptionGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventRegistrationOptionsV1ControllerDeleteOptionGroup(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventRegistrationOptionsV1ControllerDeleteOptionGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventRegistrationOptionsV1ControllerUpdateOptionGroup()` */
  static readonly EventRegistrationOptionsV1ControllerUpdateOptionGroupPath = '/v1/event-registration-options/group/{id}';

  /**
   * Required permissions: events:admin, events:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventRegistrationOptionsV1ControllerUpdateOptionGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventRegistrationOptionsV1ControllerUpdateOptionGroup$Response(
    params: {
      id: number;
      body: WorkUpdateEventRegistrationOptionGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventRegistrationOptionsService.EventRegistrationOptionsV1ControllerUpdateOptionGroupPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventRegistrationOptionsV1ControllerUpdateOptionGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventRegistrationOptionsV1ControllerUpdateOptionGroup(
    params: {
      id: number;
      body: WorkUpdateEventRegistrationOptionGroupDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventRegistrationOptionsV1ControllerUpdateOptionGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
